import { Theme } from '@mui/material';
import { STYLE_CONSTANTS } from '../../constants/styles';

const HEADER_HEIGHT = 64;
const EXTRA_HEIGHT = "0px";
export const PANEL_HEIGHTS = `calc(100vh - ${HEADER_HEIGHT}px)`;

export const productViewerStyles = {
    billingScreen: (theme: Theme, PANEL_HEIGHTS: string) => ({
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: PANEL_HEIGHTS,
        //marginTop: `${HEADER_HEIGHT}px`,
        justifyContent: 'space-between',
    }),
    categoryPanel: (theme: Theme, PANEL_HEIGHTS: string) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        minWidth: "180px",
        maxWidth: "200px",
        width: STYLE_CONSTANTS.BILLING_PANEL_CATEGORY,
        height: PANEL_HEIGHTS,
        overflowY: 'auto',
        borderRight: `1px solid ${theme.palette.divider}`,
        scrollbarWidth: 'thin',
    }),
    summaryPanel: (theme: Theme, isCartPanelOpen: boolean, PANEL_HEIGHTS: string) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        width: "100%",
        height: PANEL_HEIGHTS,
        overflowY: 'auto',
        scrollbarWidth: 'thin',
        position: "relative"
    }),
    productPanel: (theme: Theme, isCartPanelOpen: boolean, PANEL_HEIGHTS: string) => ({
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        width: isCartPanelOpen ? "60%" : STYLE_CONSTANTS.BILLING_PANEL_ITEMS,
        height: PANEL_HEIGHTS,
        overflowY: 'auto',
        scrollbarWidth: 'thin',
        position: "relative"
    }),
    rightPanel: (theme: Theme, isCartPanelOpen: boolean, PANEL_HEIGHTS: string) => ({
        height: PANEL_HEIGHTS,
        display: 'flex',
        flexDirection: "column",
        justifyContent: isCartPanelOpen ? 'end' : 'center',
        alignItems: 'start',
        backgroundColor: theme.palette.primary.light,
        transition: 'width 0.5s ease',
        //width: "30%",
        minWidth: "400px"
    }),
    toggleButton: {
        position: 'absolute',
        top: EXTRA_HEIGHT,
        right: 0,
        transform: 'translate(-6%, -0%)',
    },
};